import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Chip from "@material-ui/core/Chip";
import clsx from "clsx";

export const useStyles = makeStyles(
  (theme) => (
    {
      chipOrange: {
        backgroundColor: '#a86d32',
        fontWeight: '600',
        color: '#FFFFFF'
      },
      marginChip: {
        marginRight: '3px',
        marginLeft: '3px',
      },
    }
  )
)
export const LabelRecontagem = props  => {
  const classes = useStyles();
  return (
    <Chip size="small" label={props.label ? props.label : "Recontado"} className={clsx(classes.chipOrange, classes.marginChip)}/>
  )
}

export default LabelRecontagem;
